/**
 * 数据库相关接口
 */
import http from "../helper/http";

/**
 * 将对象组装成查询字符串
 * @param {*} obj 
 */
function makeQueryParamString(obj) {
  let queryString = '';
  for (var key in obj) {
    queryString += `${key}=${obj[key]}&`;
  }
  return queryString.endsWith('&') == true ? queryString.substring(0, queryString.length - 1) : queryString;
}

/**
 * 获取订单列表
 * @param {*} params 
 */
function getStoreOrderPageList(params) {
  return http.get('/order/getorderpagelist?' + makeQueryParamString(params));
}

/**
 * 导出订单列表
 */
function exportOrderDataList(params) {
  window.location.replace('/api/order/exportorderlist?' + makeQueryParamString(params));
}

/**
 * 物流发货
 * @param {*} params 
 */
function sendOrderWuliu(params) {
  return http.post('/order/sendorderwuli', params);
}

export default {
  getStoreOrderPageList,
  exportOrderDataList,
  sendOrderWuliu
}



// WEBPACK FOOTER //
// ./src/api/order.js